import { resetCrudSelection, useEditingStateWithCtx } from '@/atoms'
import { useCallback } from 'react'
import { useDeleteDriverAssignmentModal } from '../../../../../modals/DeleteDriverAssignmentModal'

export function useActions(driverAssignmentId: string) {
  const { setEditing } = useEditingStateWithCtx('driversAssignment')
  const { show: showDeleteDriverAssignmentModal } = useDeleteDriverAssignmentModal()

  const onEdit = useCallback(() => {
    setEditing([driverAssignmentId])
  }, [setEditing, driverAssignmentId])

  const onDelete = useCallback(() => {
    showDeleteDriverAssignmentModal()
  }, [showDeleteDriverAssignmentModal])

  const onReset = useCallback(() => {
    resetCrudSelection('driverAssignments')
  }, [])

  return {
    onDelete,
    onEdit,
    onReset,
  }
}
